module.exports = __webpack_public_path__ + "assets/img/environment-new.a09a4f46.svg";